import { Component, JSX, Prop, h } from '@stencil/core'

import { ListItem } from './air-list.types'

@Component({
  tag: 'air-list',
  styleUrl: 'air-list.scss',
  shadow: true,
})
export class AirList {
  /** Defines the list items */
  @Prop() items: ListItem[] | undefined

  /** Defines the list ordered */
  @Prop() ordered = false

  private setAttributes(item: ListItem, index: number): ListItem {
    return {
      text: item.text,
      checked: item.checked,
      order: this.ordered ? index : item.order,
    }
  }

  render(): JSX.Element {
    return (
      <div class="list-item">
        {this.items ? (
          this.items.map((item: ListItem, index: number) => {
            const order = index + 1
            const attributes = this.setAttributes(item, order)
            return <air-list-item data-key={order} {...attributes}></air-list-item>
          })
        ) : (
          <slot />
        )}
      </div>
    )
  }
}
